import * as React from 'react';
import { NavLink } from "react-router-dom"
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { Image, Space } from "antd";
import customStyles from "../../../../../assets/styles/customStyles";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import { checkCRUDPermission, getColumnWidth } from '../../../../../helpers/utilities';
import { globalActivityPrefixCounterHead } from "../../../../../config/constant";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import clsx from "clsx";


export const ListTable = (props) => {
    const { details, onRequestSort, sortOrder, sortBy, loadMore, loadMoreContent, loadMoreTask, roleManagement, onView } = props;

    const classes = customStyles();

    return (
        <CustomInfiniteScroll
            loadMore={loadMore}
            loadMoreContent={loadMoreContent}
            heads={globalActivityPrefixCounterHead}
            onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
            sortOrder={sortOrder}
            sortBy={sortBy}
            loadMoreTask={() => loadMoreTask()}
            component={
                <>
                    {
                        !loadMore || details === '' ? (
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell className={classes.textAlignCenter} colSpan={globalActivityPrefixCounterHead?.length}><div className={classes.loadMoreCircle}></div></TableCell>
                            </TableRow>
                        ) : (
                            <React.Fragment>
                                {
                                    details && Array.isArray(details) && details?.length > 0 ? details?.map((data, i) => (
                                        <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                            <TableCell style={{ width: getColumnWidth(globalActivityPrefixCounterHead, 0) }}><span style={{ width: getColumnWidth(globalActivityPrefixCounterHead, 0) }}>{data?.activityPrefix?.feature?.module?.module ?? '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(globalActivityPrefixCounterHead, 1) }}><span style={{ width: getColumnWidth(globalActivityPrefixCounterHead, 1) }}>{data?.activityPrefix?.feature?.featureName ?? '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(globalActivityPrefixCounterHead, 3) }}><span style={{ width: getColumnWidth(globalActivityPrefixCounterHead, 3) }}>{`${data?.prefix}${data?.counter}`}</span></TableCell>
                                            <TableCell>
                                                <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Global Activity Prefix Counter', 'view', 'Younote Admin') &&
                                                        <NavLink to={"#"} onClick={() => onView(data, true)}>
                                                            <Image
                                                                src={ViewIcon}
                                                                preview={false}
                                                            />
                                                        </NavLink>
                                                    }
                                                </Space>
                                            </TableCell>
                                        </TableRow>
                                    )) : (
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell className={classes.textAlignCenter} colSpan={globalActivityPrefixCounterHead?.length}>
                                                <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>No results found</p>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            </React.Fragment>
                        )
                    }
                </>
            }
        />
    )
}